var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudyHeavyRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    id: "icon-rain",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.864,12.445v-1.227c0.669-0.388,1.12-1.109,1.12-1.938 c0-1.237-1.003-2.24-2.24-2.24c-0.447,0-0.862,0.135-1.213,0.362C9.187,5.914,7.858,4.802,6.265,4.802 c-1.855,0-3.359,1.504-3.359,3.359c0,0.994,0.434,1.884,1.12,2.499v1.376c-1.337-0.774-2.24-2.218-2.24-3.875 c0-2.474,2.005-4.479,4.479-4.479c1.681,0,3.144,0.927,3.911,2.297c0.186-0.031,0.374-0.058,0.568-0.058 c1.855,0,3.36,1.505,3.36,3.36C14.104,10.743,13.169,11.983,11.864,12.445z M5.705,9.281c0.31,0,0.56,0.251,0.56,0.56v4.479 c0,0.31-0.25,0.56-0.56,0.56c-0.309,0-0.56-0.25-0.56-0.56V9.841C5.146,9.532,5.396,9.281,5.705,9.281z M7.945,10.401 c0.309,0,0.56,0.25,0.56,0.56v4.479c0,0.309-0.25,0.56-0.56,0.56c-0.31,0-0.56-0.251-0.56-0.56v-4.479 C7.385,10.651,7.636,10.401,7.945,10.401z M10.185,9.281c0.31,0,0.56,0.251,0.56,0.56v4.479c0,0.31-0.25,0.56-0.56,0.56 c-0.309,0-0.56-0.25-0.56-0.56V9.841C9.625,9.532,9.876,9.281,10.185,9.281z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudyHeavyRain);
export default __webpack_public_path__ + "static/media/cloudyHeavyRain.0a1fa701e3da060d14ff44cea41b25e2.svg";
export { ForwardRef as ReactComponent };